<template>
    <div class="cnt-section our-section">
        <div class="container p-l-30 p-r-30">
            <div class="row">
                <h4 class="col-12 section-title">How it works
                    <span class="d-block font-20">Pick a service and we will show you how it works!</span>
                </h4>
            </div>
            <div class="row row-deck">
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-box">
                        <div class="service-icon">
                            <img class="img-fluid" src="@/assets/images/icon/icon-members-orange.svg" alt="" width="24" height="24" loading="lazy">
                        </div>
                        <div class="service-cnt">
                            <h6>Membership Management</h6>
                            <p>Sign up, Create and Share.</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-box">
                        <div class="service-icon">
                            <img class="img-fluid" src="@/assets/images/icon/icon-crowdfunding-orange.svg" alt="" width="24" height="24" loading="lazy">
                        </div>
                        <div class="service-cnt">
                            <h6>Group Contributions</h6>
                            <p>Setup your Campaign, set your Goals and get Funding.</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-box">
                        <div class="service-icon">
                            <img class="img-fluid" src="@/assets/images/icon/icon-events-orange.svg" alt="" width="24" height="24" loading="lazy">
                        </div>
                        <div class="service-cnt">
                            <h6>Events</h6>
                            <p>Create and Manage your events</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-box">
                        <div class="service-icon">
                            <img class="img-fluid" src="@/assets/images/icon/icon-invoicing-orange.svg" alt="">
                        </div>
                        <div class="service-cnt">
                            <h6>Invoicing</h6>
                            <p>Add your Business, add your Customer, send a Digital Invoice.</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-box">
                        <div class="service-icon">
                            <img class="img-fluid" src="@/assets/images/icon/icon-payments-orange.svg" alt="">
                        </div>
                        <div class="service-cnt">
                            <h6>Make Payments</h6>
                            <p>Use our amazing payment infrastructure to collect payment across the world!</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-box">
                        <div class="service-icon">
                            <img class="img-fluid" src="@/assets/images/icon/icon-dollar-orange.svg" alt="">
                        </div>
                        <div class="service-cnt">
                            <h6>Receive Payments</h6>
                            <p>Receive payments securely on any device, from any bank or mobile wallet instantly!</p>
                        </div>
                    </div>
                </div> -->
                <div class="row row-deck justify-content-center">
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <!-- Shops -->
                        <div class="service-box">
                            <div class="service-icon">
                            <img class="img-fluid" src="@/assets/images/icon/icon-store.svg" alt="" width="24" height="24" loading="lazy">
                            </div>
                            <div class="service-cnt">
                            <h6>Store</h6>
                            <p>The blurb to create and manage your store to sell your paraphernalia here.</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <!-- Scan App -->
                        <div class="service-box">
                            <div class="service-icon">
                            <img class="img-fluid" src="@/assets/images/icon/icon-scan.svg" alt="" width="24" height="24" loading="lazy">
                            </div>
                            <div class="service-cnt">
                            <h6>Scanner App</h6>
                            <p>Download and scan your event attendees' tickets using this application.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ServiceComponent",
};
</script>
